import { Box, Container, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { checkAccessAdministrator } from '../../helpers/utils/RoleManager';
import useCategorizations from '../../hooks/categorizations/useCategorizations';
import CategorizationsList from './CategorizationsList.jsx';

const Categorizations = () => {
  const [contentTab, setContentTab] = useState('ToDefine');
  const profile = useSelector((state) => state?.login?.profile);
  const { data, mutate } = useCategorizations(
    profile?._id,
    contentTab === 'ToDefine' ? true : false
  );

  const handleContentChange = (event, newValue) => {
    setContentTab(newValue);
  };

  return (
    <Container maxWidth="full">
      <Box
        sx={{
          display: 'flex',
          marginLeft: -4,
        }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={contentTab}
          onChange={handleContentChange}
          sx={{ width: 180 }}
        >
          <Tab
            // icon={<PersonIcon />}
            id={0}
            value={'ToDefine'}
            label={'A définir'}
          />
          <Tab
            // icon={<PersonIcon />}
            id={0}
            value={'Defined'}
            label={'Existants'}
            disabled={!checkAccessAdministrator(profile)}
          />
        </Tabs>
        <Box
          sx={{
            padding: '0.1rem',
            width: '100%',
          }}
        >
          <CategorizationsList
            profile={profile}
            contentTab={contentTab}
            data={data}
            mutate={mutate}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default Categorizations;
